import { createAsyncAction } from 'typesafe-actions';
import { GetReposRequest, GetReposResponse, GetReposError } from './types';

export const repos = createAsyncAction(
  'GET_REPOS_REQUEST',
  'GET_REPOS_SUCCESS',
  'GET_REPOS_ERROR',
)<GetReposRequest, GetReposResponse[], GetReposError>();
